export default "<h3>File Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"